export const ENV_DEV = 'DEV'
export const ENV_TEST = 'TEST'
export const ENV_PROD = 'PROD'

const ENV = (() => {
  if (process.client) {
    const host = location.host
    let env = ENV_PROD

    if (process.env.NODE_ENV === 'development') {
      env = ENV_DEV
    } else if (host.match(/learning\-dev\.dana\.id/)) {
      env = ENV_TEST
    }

    return env
  }
  return ENV_PROD
})()

export default ENV
